import { type NonEmptyArray } from '@/packages/JsonQuery';

import { type IContext } from '../../../../utils/context';
import { nonEmptyArrayOr } from '../../../../utils/nonEmptyArrayOr';
import { type ITagGroupConfig, type TagGroupType, type TagSchema } from '../config/types';

import { TAGS_GROUPS } from './tagsGroups';

export function getTags(context: IContext): NonEmptyArray<TagSchema> | null {
  const allTags: TagSchema[] = [];

  for (const groupKey of Object.keys(TAGS_GROUPS) as TagGroupType[]) {
    const config = TAGS_GROUPS[groupKey];
    const tags = config.get(context);

    if (tags) {
      allTags.push(...tags);
    }
  }

  return nonEmptyArrayOr(allTags);
}

export function getTagGroupConfig(tagSchema: TagSchema): ITagGroupConfig {
  return TAGS_GROUPS[tagSchema.group];
}
